import * as React from 'react';
import moment from 'moment';
import { nodeListToArray } from '../../../../Static/javascript/Content/helpers/nodeListToArray';

import { GridEventProps } from '../../components/grid/event';

const GridEventView: React.StatelessComponent<GridEventProps> = props => {
    const eventMoment = moment(props.event.eventDate);
    const backgroundStyle = {
        backgroundImage: `url(${props.event.thumbnail ? props.event.thumbnail : props.text.fallbackThumbnailImageSrc})`
    };

    function highlightProductions(e) {
        let productionsToActivate = nodeListToArray(document.querySelectorAll(`[data-event="${e}"]`));
        productionsToActivate.forEach((production) => {
            production.classList.toggle('highlighted');
        })
    }

    return (
        <li className="ace-cal-grid-event" data-event={props.event.productionSeasonId}
            onMouseEnter={() => highlightProductions(props.event.productionSeasonId)}
            onMouseLeave={() => highlightProductions(props.event.productionSeasonId)}>
            <span className="ace-cal-grid-event-bg" role="presentation" style={backgroundStyle} ></span>
            <article className="ace-cal-grid-event-content">
                <p className="ace-cal-grid-event-name"><a href={props.event.viewDetailCtaUrl}>{props.event.name}</a></p>
                <p className="label">{props.event.eventTimeString}</p>

                <p className="ace-cal-grid-event-cta">
                    {
                        !props.event.buyTicketDisabled ? 
                            <a href={props.event.buyTicketCtaUrl} className="btn">{props.event.buyTicketCtaText ? props.event.buyTicketCtaText : null}</a>
                            :
                            <button  disabled className="btn">{props.event.buyTicketCtaText ? props.event.buyTicketCtaText : null}</button>
                    }
                    
                </p>
            </article>
        </li>
    );
}

export default GridEventView;